export const CHANGE_PIN_ACTION = 'CHANGE_PIN_ACTION';
export const CHANGE_PIN_SUCCESS_ACTION = 'CHANGE_PIN_SUCCESS_ACTION';
export const CHANGE_PIN_FAILURE_ACTION = 'CHANGE_PIN_FAILURE_ACTION';
